module.exports = __webpack_public_path__ + "static/media/Portuguese_European Cristiano BG-02.1dcbf087.png";